module.exports = __webpack_public_path__ + "static/oldmutual-0f897dd605264a1adb44925faf4f009c.jpg";